window.CBFrameCart = (() => {
  let pending = Promise.resolve();
  async function post(body) {
    const response = await fetch(routes.cart_change_url, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify(body)
    });
    const state = await response.json();
    if (!response.ok || state.errors || state.status) {
      throw new Error(state.description || state.message || state.errors || window.cartStrings.error);
    }
    return state;
  }
  async function change(body) {
    const response = await fetch(routes.cart_url + '.js', {headers: {'Accept': 'application/json'}});
    if (!response.ok) throw new Error(window.cartStrings.error);
    let cart = await response.json();
    const parent = body.id ? cart.items.find(item => item.key === body.id) : cart.items[Number(body.line) - 1];
    if (!parent) throw new Error(window.cartStrings.error);
    const frame = cart.items.find(item => item.parent_relationship?.parent_key === parent.key &&
      String(item.variant_id) === String(parent.properties?._cb_frame_variant));
    if (!frame || Number(body.quantity) === 0) return post({...body, id: parent.key, line: undefined});
    const group = parent.properties._cb_frame_group;
    cart = await post({id: frame.key, quantity: Number(body.quantity)});
    const currentParent = cart.items.find(item => item.properties?._cb_frame_group === group);
    try {
      return await post({...body, id: currentParent.key, line: undefined});
    } catch (error) {
      const currentFrame = cart.items.find(item => item.parent_relationship?.parent_key === currentParent.key &&
        String(item.variant_id) === String(parent.properties._cb_frame_variant));
      if (currentFrame) await post({id: currentFrame.key, quantity: frame.quantity});
      throw error;
    }
  }
  return {
    change(body) {
      const operation = pending.then(() => change(body));
      pending = operation.catch(() => {});
      return operation;
    }
  };
})();
